function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserServiceUms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 192V0h192v192z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M95.897 89.397c-18.199 0-32.948-14.75-32.948-32.949 0-18.198 14.75-32.948 32.948-32.948 18.199 0 32.949 14.75 32.949 32.948 0 18.2-14.75 32.949-32.949 32.949",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "#b5c7cd",
      fillOpacity: 1,
      strokeWidth: 1.64743,
      strokeMiterlimit: 10
    },
    d: "M95.896 102.576c-47.646 0-65.69 40.235-65.69 40.235L30 168.473h75.254a45.519 44.32 0 0 1-6.631-22.9 45.519 44.32 0 0 1 23.217-38.51c-7.464-2.741-16.067-4.487-25.944-4.487z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59baea",
      strokeWidth: 3.58333
    },
    className: "st0",
    d: "M329.707-491.34c-11.109-51.957-35.834-100.69-71.309-140.824 71.667 20.067 136.525 65.933 178.45 133.3-36.192-3.942-72.383-1.075-107.141 7.525M-59.085-127.273c51.6 58.05 123.625 95.317 201.383 103.2-19.35-30.817-33.325-64.858-40.85-100.691-51.6 12.9-106.424 12.9-160.533-2.509m322.858 91.375c164.475-49.808 257.283-223.241 207.475-387.716-8.242-27.592-20.067-53.033-34.4-75.608-36.55-3.584-72.741-1.075-107.5 7.883 12.184 57.333 8.6 118.25-13.975 177.016-37.625 97.825-119.683 165.909-214.283 189.559 7.525 35.833 21.5 69.874 40.85 100.691 40.133 3.942 81.342.717 121.833-11.825",
    transform: "matrix(.1286 0 0 .1287 121.8 188.333)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#586e7c",
      strokeWidth: 3.58333
    },
    className: "st1",
    d: "M101.448-124.764c-12.541-57.334-8.6-118.25 13.617-177.017 37.983-97.825 119.683-165.908 214.642-189.558-11.109-52.317-35.834-100.692-71.309-140.825-56.616-16.125-117.533-16.125-174.866 1.433-164.475 49.809-257.283 223.242-207.475 387.717 13.617 44.433 35.833 83.491 64.858 116.1 54.109 15.05 108.933 15.05 160.533 2.15",
    transform: "matrix(.1286 0 0 .1287 121.8 188.333)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserServiceUms);
export default __webpack_public_path__ + "static/media/userServiceUms.1e29ee78da23e768a3fe9b222940069b.svg";
export { ForwardRef as ReactComponent };